import { fn } from '@ember/helper';
import { get } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import perform from 'ember-concurrency/helpers/perform';
import eq from 'ember-truth-helpers/helpers/eq';
import EndSessionEditionForm from 'parog-web/components/hemodialysis-session/edition-form/end-session-edition-form';
import MiddleSessionEditionForm from 'parog-web/components/hemodialysis-session/edition-form/middle-session-edition-form';
import StartSessionEditionForm from 'parog-web/components/hemodialysis-session/edition-form/start-session-edition-form';
import type HemodialysisSessionDeclaredModelView from 'parog-web/models/hemodialysis-session-declared-model-view';
import PageContainer from 'ui-kit/components/page-container';
import SelectableButtonGroup from 'ui-kit/components/selectable-button-group';
import DialysisEditionForm from '../dialysis/edition-form';

interface Signature {
  Args: {
    sessionMeasurement: HemodialysisSessionDeclaredModelView;
  };
}

export default class HemodialysisSessionEditionFormComponent extends Component<Signature> {
  @tracked currentState = 'start';

  get startUltrafiltrationTotal(): number | undefined {
    return this.args.sessionMeasurement.measurementChangesets.start[0].get(
      'startUltrafiltrationTotal'
    );
  }

  <template>
    <PageContainer @title='Séance d’hémodialyse'>
      <:content>
        <DialysisEditionForm
          @sessionMeasurement={{@sessionMeasurement}}
          @currentState={{this.currentState}}
          as |submit|
        >
          <SelectableButtonGroup
            @onChange={{fn (mut this.currentState)}}
            @selected={{this.currentState}}
            @xs={{true}}
            as |Group|
          >
            <Group.Item class='small w-1/3' @value='start'>Début</Group.Item>
            <Group.Item class='small w-1/3' @value='middle'>Milieu</Group.Item>
            <Group.Item class='small w-1/3' @value='end'>Fin</Group.Item>
          </SelectableButtonGroup>

          {{#if (eq this.currentState 'start')}}
            <div class='mt-4 md:mt-0'>
              <StartSessionEditionForm
                @measurement={{get
                  @sessionMeasurement.measurementChangesets.start
                  0
                }}
                @onSubmit={{perform submit}}
              />

            </div>
          {{/if}}

          {{#if (eq this.currentState 'middle')}}
            <div class='mt-4 md:mt-0'>
              <MiddleSessionEditionForm
                @measurements={{@sessionMeasurement.measurementChangesets.middle}}
                @startUltrafiltrationTotal={{this.startUltrafiltrationTotal}}
                @onSubmit={{perform submit}}
              />
            </div>
          {{/if}}

          {{#if (eq this.currentState 'end')}}
            <div class='mt-4 md:mt-0'>

              <EndSessionEditionForm
                @measurement={{get
                  @sessionMeasurement.measurementChangesets.end
                  0
                }}
                @onSubmit={{perform submit}}
              />
            </div>
          {{/if}}

        </DialysisEditionForm>

      </:content>
    </PageContainer>
  </template>
}
